<div class="container pt-3 pb-3">
  <rbb-side-menu-headline headline="Meine Daten"
                          [description]="'Eigene Daten ansehen und Änderungen prüfen lassen'"
                          icon="fas fa-user"/>
  @if (employee) {
    @if (!employee.chiefOfOrgUnit) {
      <p class="my-5">
        Die Genehmigung von eingerichteten Organisationseinheiten, sowie eine Übersicht mit den Ihnen zugeordneten Mitarbeiterinnen und Mitarbeitern finden Sie im <a href="https://tools.rbb-online.de/mit-service/zyrus/my-employees">MIT-Serviceport</a>.
      </p>
    }
    <div class="row">
      <div class="col-12 col-lg-6 mb-3">
        <span class="fw-bold">Person</span>
        <hr class="m-0 p-0">
        <div class="row">
          <div class="col-12 mt-2">
            <label class="d-block small text-darkgray fw-bold">Name</label>
            {{employee.firstName}} {{employee.lastName}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Benutzername</label>
            {{employee.username}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">UID des Benutzerkontos</label>
            {{employee.uidNumber}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">E-Mail</label>
            {{employee.emailAddress}}
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-3">
        <span class="fw-bold">Vertrag</span>
        <hr class="m-0 p-0">
        <div class="row">
          <div class="col-12 mt-2">
            <label class="d-block small text-darkgray fw-bold">Personalnummer</label>
            {{employee.employeeNumber}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Kostenstelle</label>
            {{employee.costCentre}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Vertragstyp</label>
            @switch (employee.employeeType) {
              @case (EmployeeType.PERMANENT) {Fest}
              @case (EmployeeType.FREELANCER) {Frei}
              @case (EmployeeType.TEMPORARY) {Aushilfe}
              @case (EmployeeType.EXTERNAL) {Extern}
              @default {Unbekannt}
            }
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Vereinbarung zum mobilen Arbeiten</label>
            {{employee.mobileWorkAgreement ?? 'keine'}}
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Schwerbehinderung</label>
            {{employee.disabilityStatus ? 'Ja' : 'Nein'}}
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-3">
        <span class="fw-bold">Abteilung / Bereich</span>
        <hr class="m-0 mb-2 p-0">
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info" aria-hidden="true"></i>&ensp;Die Organisationseinheiten werden anhand des aktuellen Organigramms aus SAP ermittelt. Wenn eine Ebene in der Struktur fehlt, werden äquivalente Organisationseinheiten ermittelt. Dies gilt auch für Mitarbeiterinnen und Mitarbeiter in höheren Positionen. Für feste MA ist bereits die zugeordnete Organisationseinheit aus SAP eingerichtet. <span class="fw-bold">Freie MA müssen vor der Nutzung mindestens eine gültige Organisationseinheit (auftraggebender Bereich) einrichten.</span> Feste MA können neben der Organisationseinheit aus SAP weitere Organisationseinheiten einrichten. Die Organisationseinheiten werden zur Ermittlung des Genehmigungswegs genutzt. Es kann zu jeder Zeit zwischen vollständig gültig eingerichtete Organisationseinheiten gewechselt werden. Bitte überprüfen Sie regelmäßig Ihre Daten. Wenn Sie nicht mehr für einen Bereich arbeiten, dann bitten wir Sie diese Organisationseinheit über den Button "Verlauf" als ungültig zu markieren.</span>
        @if (hasInvalidOrgUnits()) {
          <span class="small text-secondary d-block mb-3 description-badge text-danger"><i class="fas fa-info" aria-hidden="true"></i>&ensp;Es gibt eingerichtete Org-Einheiten, bei denen veraltete Daten genutzt werden. Weitere Informationen sind im Verlauf erhältlich.</span>
        }
        <button class="btn btn-sm btn-primary" (click)="openChangeOrgUnitModal()"><i class="fas fa-edit" aria-hidden="true"></i>&ensp;Org-Einheit einrichten</button>
        <button class="btn btn-sm btn-primary ms-2" (click)="openOrgUnitsHistoryModal()"><i class="fas fa-list" aria-hidden="true"></i>&ensp;Verlauf</button>
        <div class="row">
          @if (validOrgUnits?.length) {
            <div class="col-12 mt-4">
              <label class="d-block small text-darkgray fw-bold">Verfügbare Org-Einheiten</label>
              <select class="form-select form-select-sm" id="validOrgUnits" [(ngModel)]="selectedValidOrgUnit" (ngModelChange)="setOrgUnitAsActive($event)">
                @for (validOrgUnit of validOrgUnits; track validOrgUnit.id) {
                  <option [ngValue]="validOrgUnit">{{validOrgUnit.orgUnit}} / {{validOrgUnit.costCentre}} @if (!validOrgUnit.id) {(SAP)}</option>
                }
              </select>
              @if (changingActiveOrgUnit) {
                <span class="d-block small text-primary">Aktualisiere Daten...</span>
              }
            </div>
          }
          @if (employee.orgUnit) {
            <div class="col-12 mt-4">
              <label class="d-block small text-darkgray fw-bold">Organisationseinheit</label>
              {{employee.orgUnit}}
            </div>
          }
          @if (employee.department) {
            <div class="col-12 mt-4">
              <label class="d-block small text-darkgray fw-bold">Abteilung (bzw. erste Organisationseinheit unter der Hauptabteilung)</label>
              {{employee.department}}
            </div>
          }
          @if (employee.mainDepartment) {
            <div class="col-12 mt-4">
              <label class="d-block small text-darkgray fw-bold">Hauptabteilung (bzw. erste Organisationseinheit unter der Direktion)</label>
              {{employee.mainDepartment}}
            </div>
          }
          @if (employee.directorate) {
            <div class="col-12 mt-4">
              <label class="d-block small text-darkgray fw-bold">Direktion (bzw. höchste Genehmigungsebene in rbb Forms)</label>
              {{employee.directorate}}
            </div>
          }
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-3">
        <span class="fw-bold">Vorgesetzte</span>
        <hr class="m-0 mb-2 p-0">
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info" aria-hidden="true"></i>&ensp;Die Vorgesetzten werden anhand der ermittelten Organisationsstruktur aus SAP abgeleitet. Dabei können bei fehlenden Organisationsebenen Führungskräfte unter höheren Genehmigungsebenen als vorgesehen aufgeführt werden. Direktor/in ist dabei als allgemeine höchste Genehmigungsebene in rbb Forms zu verstehen. Alle weiteren Ebenen werden entsprechend nach unten berechnet und bei fehlender Organisationsstruktur mit der untersten Führungskraft aufgefüllt. <span class="fw-bold">Im Folgenden werden die Genehmigerinnen und Genehmiger für Sie persönlich angezeigt. Je nach persönlicher Zugehörigkeit in der Organisationsstruktur sind die Bezeichnungen der Leitungsebenen nicht exakt wörtlich zunehmen.</span></span>
        <div class="row">
          <div class="col-12 mt-2">
            <label class="d-block small text-darkgray fw-bold">Vorgesetzte/r</label>
            @if (!employee.chief) {
              <small>Vorgesetzte/r nicht verfügbar</small>
            } @else {
              {{employee.chief}}<br>
              @if (employee.deputyChief) {
                {{employee.deputyChief}} <small>(Stellvertretung)</small>
              } @else {
                <small>keine Stellvertretung gepflegt</small>
              }
            }
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Kostenstellenverantwortliche/r</label>
            @if (!employee.costCentreResponsible) {
              <small>Kostenstellenverantwortliche/r nicht verfügbar</small>
            } @else {
              {{employee.costCentreResponsible}}<br>
              <!--@if (employee.deputyCostCentreResponsible) {
                {{employee.deputyCostCentreResponsible}} <small>(Stellvertretung)</small>
              } @else {
                <small>keine Stellvertretung gepflegt</small>
              }-->
            }
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Abteilungsleiter/in</label>
            @if (!employee.departmentChief) {
              <small>Abteilungsleiter/in nicht verfügbar</small>
            } @else {
              {{employee.departmentChief}}<br>
              @if (employee.deputyDepartmentChief) {
                {{employee.deputyDepartmentChief}} <small>(Stellvertretung)</small>
              } @else {
                <small>keine Stellvertretung gepflegt</small>
              }
            }
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">HA Leiter/in</label>
            @if (!employee.mainDepartmentChief) {
              <small>HA Leiter/in nicht verfügbar</small>
            } @else {
              {{employee.mainDepartmentChief}}<br>
              @if (employee.deputyMainDepartmentChief) {
                {{employee.deputyMainDepartmentChief}} <small>(Stellvertretung)</small>
              } @else {
                <small>keine Stellvertretung gepflegt</small>
              }
            }
          </div>
          <div class="col-12 mt-4">
            <label class="d-block small text-darkgray fw-bold">Direktor/in</label>
            @if (!employee.director) {
              <small>Direktor/in nicht verfügbar</small>
            } @else {
              {{employee.director}}<br>
              @if (employee.deputyDirector) {
                {{employee.deputyDirector}} <small>(Stellvertretung)</small>
              } @else {
                <small>keine Stellvertretung gepflegt</small>
              }
            }
          </div>
        </div>
      </div>
      @if (employee.orgUnit && employee.costCentre) {
        <div class="col-12 col-lg-6 mb-3">
          <span class="fw-bold">Zugriff auf andere Mitarbeiter</span>
          <hr class="m-0 p-0">
          <div class="col-12 mt-2">
            <span class="small text-secondary d-block mb-3 description-badge">Folgende Mitarbeiterinnen und Mitarbeiter haben Ihnen Zugriff auf ihre Anträge gegeben. Sie können für sie Antragsentwürfe vorbereiten und alle bereits abgeschickten Anträge einsehen. Sie können über die Navigationsleiste unter "Zugriff" einstellen, für wen Sie gerade Anträge bearbeiten und einsehen wollen.</span>
          </div>
          <div class="col-12 mt-2">
            @if (receivedAccess?.length) {
              <ul>
                @for (access of receivedAccess; track access.id) {
                  <li>{{access.firstName}} {{access.lastName}} ({{access.username}})</li>
                }
              </ul>
            } @else {
              Sie haben aktuell keine Zugriffe erhalten.
            }
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-3">
          <span class="fw-bold">Zugriff für andere Mitarbeiter</span>
          <hr class="m-0 p-0">
          <div class="col-12 mt-2">
            <span class="small text-secondary d-block mb-3 description-badge">Folgende Mitarbeiterinnen und Mitarbeiter können auf Ihre Anträge zugreifen und für Sie Antragsentwürfe vorbereiten. Sie können keine Anträge in Ihrem Namen abschicken oder sie genehmigen.</span>
          </div>
          <div class="col-12 mt-2">
            @if (givenAccess?.length) {
              <rbb-table [responsiveBreakpoint]="'lg'" [columns]="giveAccessColumns" [values]="givenAccess" [tableData]="givenAccessData"/>
              <ng-template let-column="column" let-value="value" #givenAccessData>
                <td>
                  @switch (column.field) {
                    @case ('toApprove') {
                      {{value[column.field] ? 'Ja' : 'Nein'}}
                    }
                    @case ('notifyToApprove') {
                      {{value[column.field] ? 'Ja' : 'Nein'}}
                    }
                    @case ('timestamp') {
                      {{value[column.field] | date:'dd.MM.yyyy HH:mm'}}
                    }
                    @case ('delete') {
                      <i class="d-inline-block pointer text-danger fas fa-times transform grow-effect" data-bs-toggle="tooltip" data-bs-placement="right" title="Zugriff entziehen"
                         (click)="openRevokeAccessModal(value)" (keydown.space)="openRevokeAccessModal(value)" (keydown.enter)="openRevokeAccessModal(value)" tabindex="0"></i>
                    }
                    @default {
                      {{ value[column.field] }}
                    }
                  }
                </td>
              </ng-template>
            } @else {
              Sie haben aktuell keine Zugriffe vergeben.
            }
          </div>
          <div class="col-12 mt-2">
            <button class="btn btn-sm btn-primary" (click)="openCreateAccessModal()">Zugriff gewähren</button>
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #changeOrgUnitModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Organisationseinheit einrichten</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Organisationseinheit bzw. auftraggebender Bereich auswählen</label>
          <div class="small text-info fw-bold">
            Empfehlung: Suchen Sie nach Ihrer Führungskraft, um den richtigen Bereich zu finden.
          </div>
          <input type="text" class="d-none">
          <rbb-multi-select [(ngModel)]="selectedOrgUnit" [values]="orgUnits ?? []" prependIcon="fa-solid fa-search" [itemTemplate]="orgUnitTemplate" [searchFields]="['colloquialPath', 'chief']" [max]="1"/>
          <ng-template #orgUnitTemplate let-value="value">
            <span class="d-inline-block">{{value.colloquialPath}}<br><small class="text-secondary">Führungskraft: {{value.chief}}</small></span>
          </ng-template>
          @if (selectedOrgUnit[0]) {
            <span class="small text-secondary">Ihre Anfrage wird durch die Führungskraft der ausgewählten Organisationseinheit geprüft.</span>
          }
        </div>
      </div>
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Kostenstelle auswählen</label>
          <rbb-multi-select [(ngModel)]="selectedCostCentre" [values]="costCentres ?? []" prependIcon="fa-solid fa-search" [itemTemplate]="costCentreTemplate" [searchFields]="['costCentre', 'description']" [max]="1"/>
          <ng-template #costCentreTemplate let-value="value">
            {{value.costCentre}} ({{value.description}})
          </ng-template>
        </div>
      </div>
      <div class="col-12">
        <p>Wenn Sie die Organisationseinheit einrichten wollen, wird Ihre Führungskraft eine Anfrage zur Prüfung bekommen. Die Organisationseinheit wird erst nach erfolgreicher Prüfung für Sie hinterlegt.</p>
      </div>
      <div class="col-12">
        <span class="small text-secondary d-block mb-3 description-badge"><i class="fas fa-info" aria-hidden="true"></i>&ensp;Der "Anfrage stellen"-Button wird erst aktiviert, wenn eine Organisationseinheit und eine Kostenstelle korrekt aus der Suchergebnislist ausgewählt wurde.</span>
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="sendOrgUnitRequest()"
            class="btn btn-success btn-sm" [disabled]="!selectedOrgUnit[0] || !selectedCostCentre[0]">Anfrage stellen
    </button>
    <button (click)="closeChangeOrgUnitModal()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>

<ng-template #orgUnitsHistoryModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">Verlauf der Organisationseinheiten außerhalb von SAP</h5>
    <button type="button" class="btn-close" (click)="closeOrgUnitsHistoryModal()"></button>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      @if (employeeOrgUnits && employeeOrgUnits.length) {
        <rbb-table [responsiveBreakpoint]="'lg'" [columns]="orgUnitsHistoryColumns" [values]="employeeOrgUnits" [tableData]="orgUnitsHistoryData"/>
        <ng-template let-column="column" let-value="value" #orgUnitsHistoryData>
          <td>
            @switch (column.field) {
              @case ('orgUnitPath') {
                {{getOrgUnit(value[column.field])}}
                @if (value.approved === 'APPROVED' && value.orgUnitInvalid) {
                &ensp;<i class="fa-solid fa-circle-exclamation text-danger d-inline-blick" data-bs-toggle="tooltip" data-bs-placement="top" title="Die Org-Einheit existiert nicht mehr. Eventuell wurde sie umbenannt oder umstrukturiert. Bitte richten Sie eine neue Org-Einheit ein."></i>
                }
              }
              @case ('costCentre') {
                {{getOrgUnit(value[column.field])}}
                @if (value.approved === 'APPROVED' && value.costCentreInvalid) {&ensp;<i class="fa-solid fa-circle-exclamation text-danger d-inline-blick" data-bs-toggle="tooltip" data-bs-placement="top" title="Die Kostenstelle existiert nicht mehr. Bitte richten Sie die Org-Einheit mit einer anderen Kostenstelle erneut ein. Beachten Sie dabei das Kostenstellenverzeichnis im Intranet unter Arbeitsplatz > Finanzen."></i>}
                @if (value.approved === 'APPROVED' && value.costCentreIsOld) {&ensp;<i class="fa-solid fa-circle-exclamation text-danger d-inline-blick" data-bs-toggle="tooltip" data-bs-placement="top" title="Die Kostenstelle ist veraltet. Sie können sie noch weiter nutzen, sollten aber die Org-Einheit mit einer anderen Kostenstelle erneut einrichten. Beachten Sie dabei das Kostenstellenverzeichnis im Intranet unter Arbeitsplatz > Finanzen."></i>}
              }
              @case ('approved') {
                <span class="fw-bold">
                @switch (value[column.field]) {
                  @case ('PENDING') {Ausstehend}
                  @case ('APPROVED') {Genehmigt}
                  @case ('DECLINED') {Abgelehnt}
                  @case ('CANCELED') {{{value.approvedAt ? 'Ungültig' : 'Abgebrochen'}}}
                }
                </span>
              }
              @case ('timestamp') {
                {{value[column.field] | date:'dd.MM.yyyy HH:mm'}}
              }
              @case ('approvedAt') {
                {{value[column.field] | date:'dd.MM.yyyy HH:mm'}}
              }
              @case ('approvedByFirstName') {
                {{value.approvedByFirstName}} {{value.approvedByLastName}}
              }
              @case ('canceledAt') {
                @if (value.approvedAt) {
                  {{value[column.field] | date:'dd.MM.yyyy HH:mm'}}
                }
              }
              @case ('canceledByFirstName') {
                @if (value.approvedAt) {
                  {{value.canceledByFirstName}} {{value.canceledByLastName}}
                }
              }
              @case ('delete') {
                @if (value.approved === 'PENDING' || value.approved === 'APPROVED') {
                  <button class="btn btn-sm btn-danger" (click)="orgUnitToDelete = value">
                    {{value.approved === 'PENDING' ? 'Anfrage abbrechen' : 'Als ungültig markieren' }}
                  </button>
                }
              }
              @default {
                {{ value[column.field] }}
              }
            }
          </td>
        </ng-template>
      }
    </div>
    @if (orgUnitToDelete) {
      <hr>
      <div class="row">
        @if (orgUnitToDelete.approved === OrgUnitApproved.PENDING) {
          <div class="col-12">
            Möchten Sie die Anfrage für {{orgUnitToDelete.orgUnitPath?.split('/')?.reverse()?.[0]}} / {{orgUnitToDelete.costCentre}} abbrechen?
          </div>
        }
        @if (orgUnitToDelete.approved === OrgUnitApproved.APPROVED) {
          <div class="col-12">
            Möchten Sie {{orgUnitToDelete.orgUnitPath?.split('/')?.reverse()?.[0]}} / {{orgUnitToDelete.costCentre}} als ungültig markieren? Sie können damit keine Anträge mehr für diese Organisationseinheit abschicken.
          </div>
        }
        <div class="col-12 mt-2 text-center">
          <button class="btn btn-primary btn-sm" (click)="deleteOrgUnit()">{{orgUnitToDelete.approved === OrgUnitApproved.PENDING ? 'Anfrage abbrechen' : 'Als ungültig markieren' }}</button>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="closeOrgUnitsHistoryModal()" class="btn btn-secondary btn-sm" type="button">Schließen</button>
  </div>
</ng-template>

<ng-template #createAccessModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Zugriff gewähren</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-3">
          <label>Mitarbeiter wählen</label>
          <input type="text" class="d-none">
          <rbb-multi-select [values]="accessEmployees ?? []" [max]="1" [(ngModel)]="selectedEmployee"
                            [itemTemplate]="itemTemplate" prependIcon="fas fa-user"
                            [searchFields]="['lastName', 'firstName', 'username']"/>
          <ng-template let-value="value" #itemTemplate>
            <i class="fas fa-user"></i> {{value.firstName}} {{value.lastName}} ({{value.username}})
          </ng-template>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="toApprove" [(ngModel)]="toApprove">
          <label class="form-check-label" for="toApprove">Zugriff zusätzlich für zu genehmigende Anträge gewähren (nur lesend)</label>
        </div>
        @if (toApprove) {
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" id="notifyToApprove" [(ngModel)]="notifyToApprove">
            <label class="form-check-label" for="notifyToApprove">Benachrichtigung an die Person verschicken, wenn ein neuer zu genehmigender Antrag vorliegt</label>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="createAccess()" class="btn btn-success btn-sm" [disabled]="!selectedEmployee?.length">
      Zugriff gewähren
    </button>
    <button (click)="closeCreateAccessModal()" class="btn btn-secondary btn-sm" type="button">
      Schließen
    </button>
  </div>
</ng-template>

<ng-template #revokeAccessModal>
  <div class="modal-header pb-2 pt-2">
    <h5 class="modal-title">
      <span>Zugriff entziehen</span>
    </h5>
  </div>
  <div class="modal-body p-3">
    Wollen Sie {{selectedAccess?.accessForFirstName}} {{selectedAccess?.accessForLastName}} ({{selectedAccess?.accessForUsername}}) den Zugriff entziehen?
  </div>
  <div class="modal-footer pb-2 pt-2">
    <button (click)="revokeAccess()" class="btn btn-success btn-sm">
      Zugriff entziehen
    </button>
    <button (click)="closeRevokeAccessModal()" class="btn btn-secondary btn-sm" type="button">
      Schließen
    </button>
  </div>
</ng-template>
